(function adminAuthNotificationConfigDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminAuthNotificationConfigService', [
            'restUrlBuilder', '$injector', 'config', function adminAuthNotificationService(restUrlBuilder, $injector, config) {
                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id) {
                    return restUrlBuilder.one('adminNotificationConfig', id).get();
                };

                this.create = function notificationConfigCreate(notification, files) {
                    if (notification === null)
                        throw "La configuración de notificación no puede ser null";

                    var $upload = $injector.get('Upload');
                    if ($upload === null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: restUrlBuilder.all('AdminNotificationConfig').url,
                        method: 'POST',
                        fields: { notification: JSON.stringify(notification) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };


                this.delete = function deleteNotif(id) {
                    return restUrlBuilder.one('adminNotificationConfig', id).delete();
                };

                this.get = function get(params, paginator) {
                        var params = {
                        Name: params.name,
                        TemplateName: params.templateName,
                        OrganizationalUnitId: params.organizationalUnitId,
                        ApplicationId: (params.app == null) ? null : params.app.id,
                        Enabled: params.notifEnabled,
                        Page: paginator.currentPage,
                        ItemPerPage: paginator.itemsPerPage
                    };
                    return restUrlBuilder.all('adminNotificationConfig')
                        .get({ params: params });
                };
            }
        ]);
})();